export default __webpack_public_path__ + "static/media/gallery-image-4-full.72d54bf9.jpg";